module.exports = __webpack_public_path__ + "img/apple-icon.249ccb16.svg";